import React from 'react';
import { Helmet } from 'react-helmet-async';

export const SITE = 'https://n3uro.world';
export const ORG_ID = `${SITE}/#organization`;
export const APPROVED_DESCRIPTION = 'N3URO WORLD® is a neuro-inclusive family infrastructure platform. It brings together shared language, practical family-access tools, digital membership pathways and organisational engagement to improve how families access, participate in and experience the places they live, travel, visit and use.';
export const PROVIDER = { '@id': ORG_ID };

const JsonLd = ({ data }) => (
  <Helmet>
    <script type="application/ld+json">{JSON.stringify({ '@context': 'https://schema.org', '@graph': [].concat(data) })}</script>
  </Helmet>
);

export default JsonLd;
